import {BaseResponse, EventsControllerDtoNoticeSortUpdateRequest, PerplayEventsApi} from "../../models/src";
import {fork, put, takeEvery, all} from 'redux-saga/effects';
import * as types from '../../constants/event/noticeConstants';
import config from '../../../config/config';
import EventsControllerDtoNoticeListResponse from "../../models/src/model/EventsControllerDtoNoticeListResponse";
import eventsControllerDtoNoticeListRequest from "../../models/src/model/EventsControllerDtoNoticeListRequest";
import {getErrorMessage} from "../../../utils/serverErrorCheck";
import eventsControllerDtoNoticeSortUpdateRequest
    from "../../models/src/model/EventsControllerDtoNoticeSortUpdateRequest";
import eventsControllerDtoNoticeRemoveRequest from "../../models/src/model/EventsControllerDtoNoticeRemoveRequest";

const api = new PerplayEventsApi(config.API_CLIENT)

function* noticeListRequestSaga(payload) {

    console.log("payload");
    console.log(payload);
    console.log("noticeListRequestSaga: ")

    const requestData = new eventsControllerDtoNoticeListRequest(
        payload.page,
        payload.pageLength,
    );
    requestData.status = payload.status;
    requestData.noticeType = payload.noticeType;
    requestData.searchString = payload.searchString || "";

    console.log("요청 데이터: ");
    console.log(requestData);

    try {
        const result = yield api.apiPerplayEventsNoticeListPost(
            { eventsControllerDtoNoticeListRequest: requestData},
            () => {}
        )

        const data = api.apiClient.deserialize(result, EventsControllerDtoNoticeListResponse)

        console.log("응답 데이터: ")
        console.log(data)

        if (payload.callback) {
            payload.callback(data);
        }
    }catch (e) {
        payload.error(e);
    }
}

function* noticeCreateRequestSaga(payload) {
    console.log("payload");

    const requestData = {
        beginDate :  payload.beginDate,
        endDate : payload.endDate,
        title : payload.title,
        deeplink : payload.deeplink || "-",
        opts : {
            region : payload.region,
            noticeInfo : payload.noticeInfo,
            noticeType : payload.noticeType,
        }
    }

    console.log("요청 데이터:");
    console.log(requestData);

    try {
        const result = yield api.apiPerplayEventsNoticeCreatePost(
            requestData.beginDate,
            requestData.endDate,
            requestData.title,
            requestData.deeplink,
            requestData.opts,
            () => {}
        );

        const data = api.apiClient.deserialize(result, BaseResponse);

        if (data.resultCode !== 200) {
            throw Error(`ERROR: ${data.resultCode}`);
        }
        if (payload.callback) {
            payload.callback(data);
        }

    }catch(e) {
        payload.error(e);
    }
}

function* noticeUpdateRequestSaga(payload) {
    const requestData = {
        opts : {
            noticeNo : payload.noticeNo,
            region : payload.region,
            noticeInfo : payload.noticeInfo,
            noticeType : payload.noticeType,
            beginDate :  payload.beginDate,
            endDate : payload.endDate,
            title : payload.title,
            deeplink : payload.deeplink || "-",
            enabled : payload.enabled,
        }
    }

    console.log("요청 데이터:");
    console.log(requestData);

    try {
        const result = yield api.apiPerplayEventsNoticeUpdatePost(
            requestData.opts,
            () => {}
        )

        const data = api.apiClient.deserialize(result, BaseResponse);

        if(data.resultCode !== 200) {
            throw Error(`ERROR: ${data.resultCode}`);
        }

        if (payload.callback) {
            payload.callback(data);
        }
    }catch (e) {
        payload.error(e);
    }
}

function* noticeSortUpdateRequestSaga(payload) {
    try {
        const requestData = new eventsControllerDtoNoticeSortUpdateRequest();
        requestData.sortingIndex = payload.sortingIndex;

        console.log('요청 데이터: ', requestData);

        const result = yield api.apiPerplayEventsNoticeSortUpdatePost({
            eventsControllerDtoNoticeSortUpdateRequest: requestData,
            },
        () => {}
        )
        const data = api.apiClient.deserialize(result, BaseResponse);

        if (data.resultCode !== 200) {
            throw new Error(getErrorMessage(data));
        }

        payload.callback(data);

    }catch (e) {
        payload.error(e);
    }

}

function* noticeDeleteRequestSaga(payload) {

    const requestData = new eventsControllerDtoNoticeRemoveRequest();

    requestData.noticeNo = payload.noticeNo;

    console.log("요청 데이터:");
    console.log(requestData);

    try {
        const result = yield api.apiPerplayEventsNoticeRemovePost({
                eventsControllerDtoNoticeRemoveRequest : requestData,
            },
            () => {}
        )

        const data = api.apiClient.deserialize(result, BaseResponse);

        if (data.resultCode !== 200) {
            throw new Error(getErrorMessage(data));
        }

        if(payload.callback) {
            payload.callback(data);
        }
    }catch (e) {
        payload.error(e);
    }

}

function* noticeSaga() {
    yield all([
        takeEvery(types.NOTICE_LIST_REQUEST, noticeListRequestSaga),
        takeEvery(types.NOTICE_CREATE_REQUEST, noticeCreateRequestSaga),
        takeEvery(types.NOTICE_UPDATE_REQUEST, noticeUpdateRequestSaga),
        takeEvery(types.NOTICE_SORT_UPDATE_REQUEST, noticeSortUpdateRequestSaga),
        takeEvery(types.NOTICE_DELETE_REQUEST, noticeDeleteRequestSaga)
    ])
}

const noticeSagas = [
    fork(noticeSaga),
];

export default noticeSagas;